import { Box } from '@chakra-ui/react';

const Handle = ({ pos, onMouseDown }) => {
    const cursorMap = {
        n: 'ns-resize',
        s: 'ns-resize',
        e: 'ew-resize',
        w: 'ew-resize',
        ne: 'nesw-resize',
        sw: 'nesw-resize',
        nw: 'nwse-resize',
        se: 'nwse-resize',
    };
    const positionMap = {
        n: {
            top: '-6px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '32px',
            height: '12px',
        },
        s: {
            bottom: '-6px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '32px',
            height: '12px',
        },
        e: {
            right: '-6px',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '32px',
            width: '12px',
        },
        w: {
            left: '-6px',
            top: '50%',
            transform: 'translateY(-50%)',
            height: '32px',
            width: '12px',
        },
        ne: { top: '-6px', right: '-6px', width: '24px', height: '24px' },
        nw: { top: '-6px', left: '-6px', width: '24px', height: '24px' },
        se: {
            bottom: '-6px',
            right: '-6px',
            width: '24px',
            height: '24px',
        },
        sw: { bottom: '-6px', left: '-6px', width: '24px', height: '24px' },
    };
    return (
        <Box
            onMouseDown={(e) => onMouseDown(e, pos)}
            position="absolute"
            zIndex="50"
            bg="transparent"
            cursor={cursorMap[pos]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            {...positionMap[pos]}
            _hover={{
                '.handle-inner': {
                    bg: 'messenger.600',
                    transform: ['ne', 'nw', 'se', 'sw'].includes(pos)
                        ? 'scale(1.5)'
                        : 'none',
                },
            }}>
            {['ne', 'nw', 'se', 'sw'].includes(pos) ? (
                <Box
                    className="handle-inner"
                    w="8px"
                    h="8px"
                    bg="messenger.600"
                    borderRadius="sm"
                    border="1px solid white"
                    shadow="sm"
                    transition="transform 0.2s"
                />
            ) : (
                <Box
                    className="handle-inner"
                    bg="messenger.600"
                    opacity="0.3"
                    borderRadius="full"
                    transition="background 0.2s"
                    w={pos === 'n' || pos === 's' ? '32px' : '4px'}
                    h={pos === 'n' || pos === 's' ? '4px' : '32px'}
                />
            )}
        </Box>
    );
};

export { Handle };
